module.exports = __webpack_public_path__ + "static/media/message.16e0eb4c.svg";